module.exports = __webpack_public_path__ + "img/card-cup.4ce7e88d.png";